<!-- src/app/accept-invitation/accept-invitation.component.html -->

<div class="accept-invitation-container">
  <!-- Loading Indicator -->
  <div *ngIf="isLoading" class="loading">
    <mat-spinner></mat-spinner>
    <p>Processing your invitation...</p>
  </div>

  <!-- Error Message -->
  <div *ngIf="!isLoading && errorMessage" class="error-container">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Error</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ errorMessage }}</p>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Dashboard Rendering -->
  @if (!isLoading && !errorMessage) {
    <div class="dashboard">
      <div class="column left-column">
        <div class="column-content">
          <app-header></app-header>
          <router-outlet></router-outlet>
        </div>
      </div>
      <div class="column right-column">
        <img id="path" src="assets/images/application.png" alt="Path to applying"/>
        <img id="logo" src="assets/images/logo-white.svg" alt="Transend logo" />
      </div>
    </div>
  }
</div>
